import script from "./VNotificationTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./VNotificationTitle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__